module.exports = __webpack_public_path__ + "static-portal/img/xxt.286d9c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xxt.jpg
// module id = Q4Th
// module chunks = 4